import { TranscriptOld } from 'src/models/TranscriptOld'
import { Transcript } from 'src/models/Transcript'
import { TranscriptionDocumentMetadata } from 'src/models/TranscriptionDocumentMetadata'
import { Testimony } from 'src/models/Testimony'
import { VisorHttpClientInterface } from 'src/network/HttpClientInterface'

export class MockVisorClient implements VisorHttpClientInterface {
    async getMetadata(transcriptionDocumentId: string): Promise<TranscriptionDocumentMetadata> {
        await document.mocks.isReady()
        console.log('[MockVisorClient] getMetadata called with ID:', transcriptionDocumentId)
        console.log('[MockVisorClient] getMetadata returning:', document.mocks.getTranscriptionDocumentMetadata())
        const metadata = document.mocks.getTranscriptionDocumentMetadata()

        return this.hydrateMetadata(metadata)
    }

    private hydrateMetadata(metadata: TranscriptionDocumentMetadata): TranscriptionDocumentMetadata {
        return {
            ...metadata,
            uploadedAt: metadata.uploadedAt instanceof Date ? metadata.uploadedAt : new Date(metadata.uploadedAt),
        }
    }

    async getTranscript(transcriptionDocumentId: string): Promise<Transcript> {
        await document.mocks.isReady()
        console.log('[MockVisorClient] getTranscript called with ID:', transcriptionDocumentId)
        console.log('[MockVisorClient] getTranscript returning:', document.mocks.getInitialTranscript())
        const transcriptOld = this.hydrateTranscript(document.mocks.getInitialTranscript())

        return Transcript.fromOldStructure(transcriptOld)
    }

    private hydrateTranscript(transcript: TranscriptOld) {
        transcript.recordingStartedAt = new Date(transcript.recordingStartedAt)

        return transcript
    }

    private orderDataToTestimony(): Testimony {
        const { collections, ...rest } = document.mocks.getOrderData()

        return { ...rest, cases: collections }
    }

    async getTestimony(): Promise<Testimony> {
        await document.mocks.isReady()

        return this.orderDataToTestimony()
    }

    async updateTestimony(): Promise<Testimony> {
        await document.mocks.isReady()

        return this.orderDataToTestimony()
    }
}
